<template>
  <StarRating
    :star-size="16"
    :active-color="muted ? GREY : YELLOW"
    :max-rating="10"
    :padding="7"
    @rating-selected="onInput"
    :read-only="readOnly"
    :rating="value"
    :show-rating="showText"
  />
</template>

<script>
import _ from 'lodash'
import StarRating from 'vue-star-rating'

const YELLOW = '#ffcc33'
const GREY = '#999'

export default {
  components: {
    StarRating,
  },
  props: {
    value: { type: Number, default: 0 },
    showText: { type: Boolean, default: true },
    readOnly: { type: Boolean, default: false },
    muted: { type: Boolean, default: false },
  },
  computed: {
    YELLOW: () => YELLOW,
    GREY: () => GREY,
  },
  methods: {
    onInput(newValue, oldValue, event) {
      console.log('=> onInput event:', event)
      if (oldValue === undefined && newValue === 0) {
        // this is initial event, broadcasted when component is created, do not propagate
        return
      }
      if (newValue === this.value) {
        // clicking same value for the second time does nothing. Before we had here
        // code that would "reset" value to zero. However, this event is triggered also
        // when we click on a star and then i.e. hit "esc" key (to close rating modal)
        // this caused very strange behaviour, i.e. user meant to close modal but what
        // really happened is she reset the value to zero and closes modal!
      } else {
        this.$emit('input', newValue)
      }
    },
  },
}
</script>
